import { ContentfulFile } from './ContentfulFile';
import { ContentfulModel, GetByIdType } from './ContentfulModel';

export class Asset extends ContentfulModel {
    private title: string;
    private description: string;
    private file: ContentfulFile;

    parseContentfulData(object: any): void {
        this.title = object.title;
        this.description = object.description;
        this.file = object.file;
    }

    getTitle(): string {
        return this.title;
    }

    getDescription(): string {
        return this.description;
    }

    getFile(): ContentfulFile {
        return this.file;
    }

    getType(): string {
        return 'asset';
    }
};
